<template>
  <div id="ErrorModal">
    <h3>{{ title }}</h3>
    <div class="brand-text" v-html="error"></div>
    <div class="pt-5" v-if="redirect">
      <b-button class="btn-theme-aware" @click="closeModalRedirect()" squared
        >Go back to Bupa Touch</b-button
      >
    </div>
    <div class="pt-5" v-else>
      <b-button class="btn-theme-aware" @click="closeModal()" squared
        >Okay</b-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    error: {
      type: String,
      default:
        "Please try again. <br /> <br /> If the problem persists please call us on <b>0345 608 0898</b>. We’re here to help Mon-Fri 8am-6pm, Sat 8am-4pm",
    },
    redirect: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Sorry, we've had a problem",
    },
    goBack: {
      type: Boolean,
      default: false,
    },
    bupaTouchLink: {
      type: String,
      default: "",
    },
    onNavigate: Function,
  },
  name: "ErrorModal",
  beforeDestroy() {
    if (this.redirect && this.bupaTouchLink) {
      window.open(this.bupaTouchLink, "_self");
    }
    if (this.goBack) {
      this.onNavigate?.("/gp");
    }
  },
  methods: {
    closeModal() {
      this.$emit("close");
      if (this.goBack) {
        this.onNavigate?.("/gp");
      }
    },
    closeModalRedirect() {
      if (this.bupaTouchLink) {
        window.open(this.bupaTouchLink, "_self");
      }
    },
  },
};
</script>
<style lang="less">
#ErrorModal {
  h3 {
    font-size: 2.4rem;
    font-weight: 700;
    font-family: var(--font-regular, "Montserrat", serif);
    padding-bottom: 30px;
    letter-spacing: normal;
    text-align: center;
  }

  font-size: 1.8rem;
  font-family: var(--font-regular, "Montserrat", serif);
  padding: 60px 20px;
  text-align: center;
  letter-spacing: normal;

  .btn-theme-aware {
    background-color: var(--brand-primary);
    border-color: var(--brand-primary);
    color: #fff;
    padding: 16px 24px;
    font-family: var(--font-bold, "DMSans Bold");
    letter-spacing: normal;
    border-radius: 15px !important;

    &:hover,
    &:focus,
    &:active {
      background-color: var(--brand-primary);
      border-color: var(--brand-primary);
      opacity: 0.9;
    }
  }
}
</style>
